<template>
    <label class="ui-switch" :class="{ 'checked': value }">
        <input type="checkbox" class="ui-switch-input"
               :name="name"
               ref="checkbox"
               :checked="value"
               @input="$emit('input', $event.target.checked)">
        
        <div class="ui-switch-track"></div>
        <div class="ui-switch-thumb"></div>
        
        <div class="ui-switch-focus-ring"></div>
    </label>
</template>

<script>
    export default {
        name: "Toggle",
        props: {
            name: {
                type: String,
                default: "toggle"
            },
            value: {
                type: Boolean,
                default: false
            },

        }
    }
</script>